exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-route-data[data-v-38ae8140] {\n  color: #ccc;\n  text-align: center;\n  margin-top: 50px;\n  line-height: 30px;\n}\n", ""]);

// exports
